module.exports = __webpack_public_path__ + "static/media/ipad-pro.df7d3430.png";